import * as React from 'react';

function SvgLeafOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.488, d: "M8.11 11.86c4.03 3.796 8.202 6.046 13.687 6.89M15.088 8.035c-4.166-2.691-8.479-.76-12.463-4.978-.928-.984-.39 11.04 4.598 15.595 3.647 3.328 9.277 2.957 11.175-.277 1.899-3.235.857-7.649-3.31-10.34v0z" })));
}

export default SvgLeafOutline;
